module.exports = __webpack_public_path__ + "static/media/1997-Camera-icon.b4d1b913.png";